export default function () {
    this.load()
}
